export default () => {
  return new Date().getTime() > new Date("2024-05-09 21:59:59.000Z").getTime()
}
